// extracted by mini-css-extract-plugin
module.exports =  {"select":"R5dOOEgu3vcE_xxXfJEN"};